<template>
    <div class="form-send-message">
        <div class="discussion-preview-div" v-if="files.length != 0">
            <ul class="discussion-preview">
                <li v-for="(item, key) in files" :key="key" @click="clearInputFile(item.url)">
                <i class="fa-solid fa-circle-xmark"></i>
                <img class="discussion-preview-image" :src="item.url" />
                </li>
            </ul>
        </div>

        <div class="reply-toolbar" v-if="templatesFeatureEnabled">
            <div class="template-trigger-wrapper">
                <TemplateTrigger :open="showTextTemplatePicker" @open="openTextTemplatePicker">
                    <span class="template-trigger-label" :class="{ triggered: showTextTemplatePicker }">
                        <i class="fa-regular fa-swatchbook"></i>
                        {{ $t('dash.templates.apply-text') }}
                    </span>
                </TemplateTrigger>
                <TemplatePicker
                    v-if="showTextTemplatePicker"
                    :action="textTemplateAction"
                    type="text"
                    :secondary-types="['affix']"
                    :save-data="message ? { data: { text: textTemplateSaveText }, source: 'moderation-dm' } : null"
                    @apply="applyTextTemplate"
                    @saved="showTextTemplatePicker = false"
                    @close="showTextTemplatePicker = false"
                />
            </div>
        </div>

        <div id="send">


            <div class="footer-form-send">
                <div class="left">
                    <label class="upload-file" v-if="activeMedia">
                        <i class="fa-regular fa-paperclip"></i>
                        <input ref="inputFiles" hidden type="file" id="attachment" name="attachment" class="inputfile form-control" :accept="acceptTypeMedia" @change="addPreviewFiles"/>
                    </label>

                    <div class="template-trigger-wrapper" v-if="activeMedia && templatesFeatureEnabled">
                        <TemplateTrigger :can-save="false" :open="showMediaTemplatePicker" @open="action => { mediaTemplateAction = action; showMediaTemplatePicker = true }">
                            <Tooltip :text="$t('dash.templates.apply-media')" position="top">
                                <span class="template-trigger" :class="{ triggered: showMediaTemplatePicker }">
                                    <i class="fa-regular fa-image"></i>
                                </span>
                            </Tooltip>
                        </TemplateTrigger>
                        <TemplatePicker
                            v-if="showMediaTemplatePicker"
                            :action="mediaTemplateAction"
                            type="media"
                            @apply="applyMediaTemplate"
                            @close="showMediaTemplatePicker = false"
                        />
                    </div>
                </div>
                <div class="middle">
                    <div class="container-textarea">
                        <textarea @input="resize()" id="textmessage" height="80px" width="100%" v-model="message" ref="inputmessage"></textarea>
                        <span class="emoji-trigger" v-click-outside="hideEmojiPicker" :class="{ triggered: showEmojiPicker }" @click="toggleEmojiPicker()">
                            <picker :data="emojiIndex" v-show="showEmojiPicker" title="Pick your emoji..." emoji="point_up" @select="addEmoji"/>
                            <i class="fa-regular fa-face-smile"></i>
                        </span>
                    </div>
                </div>
                <div class="right">
                    <i class="fa-regular fa-paper-plane-top" @click="onSubmitMessage"></i>
                </div>
            </div>
        </div>
    </div>
     <!--@keyup.enter.native="onSubmitMessage"-->
</template>

<script>

import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import emojiData from '@/constants/emoji-mart-vue-fast/all.json'
import TemplatePicker from '@/components/dash/shared/TemplatePicker.vue'
import TemplateTrigger from '@/components/dash/shared/TemplateTrigger.vue'
import TemplatesFeatureFlag from '@/components/mixins/TemplatesFeatureFlag.vue'
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
import ClickOutside from 'vue-click-outside'
import { getCaret, insertAtCaret, selectedOrAll, restoreCaret } from '@/utils/textTemplate'


    export default {
        mixins: [TemplatesFeatureFlag],

        directives: {
            ClickOutside
        },

        props: {
            activeMedia : {
                type: Boolean,
                default: true
            },
            acceptTypeMedia : {
                type: String,
                default: "video/*, image/*"
            },
            setAutofocus : {
                type: Boolean,
                default: false
            }
        },


        components: {
            Picker,
            TemplateTrigger,
            TemplatePicker,
            Tooltip,
        },

        watch: {
            setAutofocus() {
                if(this.setAutofocus && this.$refs.inputmessage) {
                    this.$refs.inputmessage.focus()
                    this.$emit('autoFocused', true)
                }
            }
        },

        data() {
            return {
                message: '',
                files : [],
                showEmojiPicker : false,
                showTextTemplatePicker: false,
                textTemplateAction: 'apply',
                textTemplateCaret: null,
                showMediaTemplatePicker: false,
                mediaTemplateAction: 'apply',
                emojiIndex: new EmojiIndex(emojiData),
            }
        },

        computed: {
            textTemplateSaveText() {
                return selectedOrAll(this.message, this.textTemplateCaret)
            },
        },

        methods: {
            resize() {
                let element = this.$refs["inputmessage"];

                element.style.height = "auto";
                element.style.height = element.scrollHeight + "px";
            },
 
            onSubmitMessage(e) {
                let formData = new FormData()
                if (this.message && this.message.length) {
                    formData.append('message', this.message)
                }

                for (var i = 0; i < this.files.length; i++) {
                    formData.append("file[]", this.files[i].file);
                }
                console.log("formData |||||| ",formData)
                
                this.$emit('onSubmitMessage', formData, this.files.map((file) => file.url))
                this.message = null
                this.files = []
            },

            addPreviewFiles(event) {
                for (var file of event.target.files) {
                    // this.files.push({
                    //     url : URL.createObjectURL(file),
                    //     file : file
                    // })

                    this.files = [{
                        url : URL.createObjectURL(file),
                        file : file
                    }]
                }

               
                this.$refs.inputFiles.value = ""
            },

            clearInputFile(url) {
                this.files = this.files.filter(file => file.url !== url)
            },

            openTextTemplatePicker(action) {
                this.textTemplateCaret = getCaret(this.$refs.inputmessage, this.message)
                this.textTemplateAction = action
                this.showTextTemplatePicker = true
            },

            applyTextTemplate(template) {
                const current = this.message || ''
                let caret = null
                if (template.type === 'affix') {
                    this.message = `${template.data.prefix || ''}${current}${template.data.suffix || ''}`
                } else {
                    const result = insertAtCaret(current, template.data.text, this.textTemplateCaret)
                    this.message = result.value
                    caret = result.caret
                }
                this.showTextTemplatePicker = false
                // resize() is normally only triggered by the textarea's own @input event - setting
                // v-model programmatically here doesn't fire that, so the box would otherwise stay
                // at whatever height it had before the template was applied.
                this.$nextTick(() => {
                    this.resize()
                    if (caret !== null) restoreCaret(this.$refs.inputmessage, caret)
                })
            },

            // the DM upload flow only accepts a real File (sent as multipart file[]) - a media
            // template only stores the S3 url(s), so it's re-fetched into a File the same way
            // PostCreator.vue already does for a duplicated post's url-based files. DM only
            // supports a single attachment, so a multi-file template only contributes its first.
            async applyMediaTemplate(template) {
                this.showMediaTemplatePicker = false

                const first = template.data && Array.isArray(template.data.files) && template.data.files[0]
                if (!first || !first.url) return

                try {
                    const response = await fetch(first.url)
                    const blob = await response.blob()
                    const file = new File([blob], template.name || 'media', { type: first.mimetype || blob.type })
                    this.files = [{ url: URL.createObjectURL(file), file }]
                } catch (error) {
                    console.error('Error fetching template media:', error)
                }
            },

            // Method for Emoji
            toggleEmojiPicker() {
                this.showEmojiPicker = !this.showEmojiPicker
            },

            hideEmojiPicker() {
                this.showEmojiPicker = false
            },

            addEmoji(emoji) {
                const cursorPosition = this.getInputSelection(this.$refs.inputmessage)
                this.message = this.message ? this.message : ''
                const start = this.message.substring(0, cursorPosition.start)
                const end = this.message.substring(cursorPosition.end)
                this.message = start + emoji.native + end
                console.log('emoji added:', this.message)
                this.$refs.inputmessage.focus()
                this.$nextTick(() => {
                    this.$refs.inputmessage.selectionStart = (start + emoji.native).length
                    this.$refs.inputmessage.selectionEnd = (start + emoji.native).length
                });
                this.hideEmojiPicker()
            },

            getInputSelection(el) {
            var start = 0,
                end = 0,
                normalizedValue,
                range,
                textInputRange,
                len,
                endRange

            if (
                typeof el.selectionStart == 'number' &&
                typeof el.selectionEnd == 'number'
            ) {
                start = el.selectionStart
                end = el.selectionEnd
            } else {
                range = document.selection.createRange()

                if (range && range.parentElement() == el) {
                len = el.value.length
                normalizedValue = el.value.replace(/\r\n/g, '\n')

                // Create a working TextRange that lives only in the input
                textInputRange = el.createTextRange()
                textInputRange.moveToBookmark(range.getBookmark())

                // Check if the start and end of the selection are at the very end
                // of the input, since moveStart/moveEnd doesn't return what we want
                // in those cases
                endRange = el.createTextRange()
                endRange.collapse(false)

                if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
                    start = end = len
                } else {
                    start = -textInputRange.moveStart('character', -len)
                    start += normalizedValue.slice(0, start).split('\n').length - 1

                    if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
                    end = len
                    } else {
                    end = -textInputRange.moveEnd('character', -len)
                    end += normalizedValue.slice(0, end).split('\n').length - 1
                    }
                }
                }
            }

            return {
                start: start,
                end: end
            }
            },
        },
    }
</script>
